import { FC } from "react";
import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCompetitionMatchday } from "../../../../openapi/api-client";
import { v4 as uuid } from "uuid";

interface CreateMatchdayModalProps {
  opened: boolean;
  onClose: () => void;
  competitionId: string;
}

export const CreateMatchdayModal: FC<CreateMatchdayModalProps> = ({
  opened,
  onClose,
  competitionId,
}) => {
  const queryClient = useQueryClient();

  const form = useForm<{ name: string }>({
    initialValues: {
      name: "",
    },
    validate: {
      name: (value) => (!value.trim() ? "Name erforderlich" : null),
    },
  });

  const createMatchdayMutation = useMutation({
    mutationFn: createCompetitionMatchday,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["competition", { competitionId }],
      });
      onClose();
      form.reset();
    },
  });

  const handleSubmit = form.onSubmit(async (values) => {
    await createMatchdayMutation.mutateAsync({
      id: competitionId,
      matchdayId: uuid(),
      name: values.name,
    });
  });

  const handleClose = () => {
    onClose();
    form.reset();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="Neuer Spieltag">
      <form onSubmit={handleSubmit}>
        <Stack>
          <TextInput
            label="Name"
            placeholder="z.B. Vorrunde, Halbfinale, Finale"
            required
            {...form.getInputProps("name")}
          />

          <Group justify="flex-end">
            <Button variant="default" onClick={handleClose}>
              Abbrechen
            </Button>
            <Button type="submit" loading={createMatchdayMutation.isPending}>
              Spieltag erstellen
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};
